var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type === 'msku')?[_vm._v("商品标题/MSKU")]:_vm._e(),(_vm.type === 'asin')?[_vm._v("商品标题/ASIN")]:_vm._e(),(_vm.type === 'variationAsin')?[_vm._v("商品标题/父ASIN")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }